import { createClient } from "@supabase/supabase-js";
import { config } from "@/app/config";
import type { Database } from "@/types/database";

/**
 * Singleton Supabase client.
 *
 * Default gotrue behavior is intentional — the Flutter app relies on the
 * same defaults (session persisted to storage, auto refresh on). Do not add
 * `flowType: 'pkce'` or a custom storage adapter unless the Flutter app's
 * auth behavior changes first; see docs/auth.md in MIGRATION.md notes.
 */
export const supabase = createClient<Database>(
  config.supabaseUrl,
  config.supabaseAnonKey,
);
